import React, { Component } from "react";
import uuid from "../../utils/uuid";
// import echarts from 'echarts';
import loadEcharts from "./loadEcharts";
class Charts extends Component {
  constructor(props) {
    super(props);
    this.id = uuid();//保证唯一，有的组件会复制子组件
  }

  // 更新数据重新初始化视图
  componentDidUpdate() {
    this.initChart();
  }
  // 首次加载初始化视图
  componentDidMount() {
    loadEcharts(() => {
      this.initChart();
    });
  }
  componentWillUnmount(){
    if (this.resize){
      window.removeEventListener("resize", this.resize)
    }
  }

  initChart = () => {
    let option = this.props.option;
    let dom = document.getElementById(this.id);
    if (!dom) return;
    let myChart = window.echarts.init(dom, this.props.theme && this.props.theme !== "light" ? "ITOCS-theme-" + this.props.theme : "ITOCS-theme-light");
    // 绘制图表
    myChart.setOption(option, {
      notMerge: true,
    });
    myChart.resize();
    this.resize = () => {
      myChart && myChart.resize();
    }
    window.addEventListener("resize", this.resize)
  };

  render() {
    return (
      <div
        id={this.id}
        style={this.props.style || { width: "100%", height: "100%" }}
      ></div>
    );
  }
}

export default Charts;
